import Swal from 'sweetalert2'
import { theme, textToHTML } from './dom'

const classShowHide = {
  showClass: {
    popup: 'swal2-popup fade-in-up',
  },
  hideClass: {
    popup: 'swal2-popup fade-out-down',
  },
}

const alert = async (title, text, type) => {
  const color = `text-${type}`
  const iconHtml = `<i class="fa-solid ${color} fa-circle-${type == 'error' ? 'xmark' : 'check'}"></i>`
  Swal.fire({
    theme: theme(),
    title,
    html: textToHTML(text),
    iconHtml,
    showConfirmButton: false,
    showCloseButton: true,
    customClass: {
      title: color,
    },
    ...classShowHide,
  })
}

export const alertSuccess = async (title, text = null) => {
  alert(title, text, 'success')
}

export const alertError = async (title, text = null) => {
  alert(title, text, 'danger')
}

export const confirm = async (title) => {
  const options = {
    theme: theme(),
    title,
    iconHtml: `<i class="fa-solid fa-circle-question text-body"></i>`,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    customClass: {
      title: 'text-body',
      confirmButton: 'btn btn-primary rounded-3',
      cancelButton: 'btn btn-outline-primary rounded-3',
    },
    ...classShowHide,
  }

  return (await Swal.fire(options)).isConfirmed
}

// bottom-up sheet holding server-rendered markup
const htmlDialog = (html, options = {}) => {
  Swal.fire({
    html,
    theme: theme(),
    showConfirmButton: false,
    showCloseButton: true,
    ...classShowHide,
    ...options,
  })
}

export const scheduleSuccess = async (html) => {
  htmlDialog(html, {
    didOpen: () => {
      Swal.getPopup()
        .querySelectorAll('.btn')
        .forEach((btn) => {
          btn.addEventListener('click', () => {
            Swal.close()
          })
        })
    },
  })
}

// the markup owns its own buttons (a submit included), so nothing is auto-wired to close
export const formDialog = async (html, options = {}) => {
  htmlDialog(html, options)
}

export const closeDialog = () => {
  Swal.close()
}
